import z from "zod";

export const UserSchema = (user, list) =>
  z
    .object({
      firstName: z
        .string()
        .trim()
        .nonempty({ message: "First name is required." }),
      lastName: z
        .string()
        .trim()
        .nonempty({ message: "Last name is required." }),
      organization: z.string().trim().optional(),
      email: z
        .string()
        .trim()
        .min(1, "Email is required.")
        .pipe(z.email("Must be a valid email."))
        .refine(
          (email) =>
            !list.some(
              (u) =>
                u.id !== user.id &&
                u.email.toLowerCase().trim() === email.toLowerCase(),
            ),
          { message: "Email address already in use." },
        ),
      phoneNumber: z.string().trim().optional(),
      enabled: z.boolean().optional(),
      roles: z.array(z.string()).optional(),
      password: !user.id
        ? z.string().trim().nonempty({ message: "Password is required." })
        : z.string().optional(),
      confirmPassword: !user.id
        ? z
            .string()
            .trim()
            .nonempty({ message: "Password confirmation is required." })
        : z.string().optional(),
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: "Passwords don't match.",
      path: ["confirmPassword"],
    });

export const UserDefaultValues = (user) => ({
  firstName: user.firstName ?? "",
  lastName: user.lastName ?? "",
  organization: user.organization ?? "",
  email: user.email ?? "",
  phoneNumber: user.phoneNumber ?? "",
  enabled: user.enabled ?? true,
  roles: user?.roles?.includes("ADMIN") ? ["ADMIN"] : ["USER"],
  password: user.password ?? "",
  confirmPassword: user.confirmPassword ?? "",
});
